import styled, { css } from 'styled-components';

const Container = styled.div.attrs((props: any) => ({
  flexDirection: props.flexDirection,
  withSeparator: props.withSeparator
}))`
  padding: 0 32px 32px 32px;
  display: flex;
  align-items: center;
  flex-direction: column;
  color: var(--text-text02);

  span.contentTitle {
    font-weight: 900;
    font-size: 20px;
    line-height: 32px;
    margin: 16px 0 16px 0;
    text-align: center;
  }
  p.contentSubtitle {
    text-align: center;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
  }
  p.contentSubtitle0 {
    text-align: center;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    margin-bottom: 8px;
  }
  div.contentInfo {
    background: #ecf4f9;
    border-radius: 8px;
    padding: 8px 16px;
    display: flex;
    justify-content: space-between;
    margin-top: 16px;
  }
  div.contentInfo cc-icon {
    margin-right: 8px;
  }
  span.contentInfoText {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
  }
  div.buttonContainers {
    display: flex;
    gap: 16px;
    margin-top: 32px;
    flex-direction: column;
    width: 100%;

    ${({ flexDirection }) =>
      flexDirection &&
      css`
        @media (min-width: 640px) {
          flex-direction: row;
        }
      `};
  }
  div.buttonContainersColumn {
    display: flex;
    margin-top: 24px;
    gap: 24px;
    flex-direction: column;
    width: 100%;
    justify-content: center;
    align-items: center;
  }
  div[class*='buttonContainers'] button {
    min-height: 44px;
    width: 100%;
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    background-color: var(--nb-primary);
    padding: 10px 24px;
    color: #ffffff;
    border-radius: 4px;
    white-space: nowrap;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  button.contentButton:hover {
    background-color: var(--primary-hover);
  }
  button.contentButton:active,
  button.contentButton:focus {
    background-color: var(--primary-focus);
  }

  button.contentButton2 {
    background-color: #fff !important;
    border: 1px solid;
    color: var(--text-primary) !important;
  }

  button.contentButton2:hover {
    background-color: var(--button-secondary-hover) !important;
  }
  button.contentButton2:focus {
    background-color: var(--button-secondary-focus) !important;
  }

  @media (min-width: 768px) {
    div.buttonContainers {
      flex-direction: row;
      width: 100%;
      justify-content: center;
    }
    div.buttonContainers button {
      width: max-content;
    }
  }
`;

export { Container };
